/**
 * ShopStatistics Component
 * --
 * 작성자 - Owen
 * 작성일 - 2025 07 11 금요일
 * 마지막 수정일 - 2025 07 16 수요일
 */
import { Table } from 'antd';
import { Content } from 'components';
import React from 'react';
import { stringToMoneyFormat } from 'utils';

const ShopStatistics = (props) => {
  /**
   * SECTION - Props
   */
  const {
    type = 'daily',
    orders = [],
    delivery = [],
    subscription = [],
    rental = [],
    setSummaryColumns = () => {},
    disabled = [],
  } = props;
  /**!SECTION - Props */

  /**
   * SECTION - Function
   */
  const setData = React.useCallback(
    (d) => setSummaryColumns(d),
    [setSummaryColumns]
  );
  /**!SECTION - Function */

  /**
   * SECTION - Hooks
   */
  // Column 설정
  const Columns = React.useMemo(() => {
    switch (type) {
      case 'daily':
      case 'products':
      case 'options':
      case 'timezone':
      case 'payments':
      case 'category': {
        return [
          {
            title: '',
            key: 'total',
            dataIndex: 'total',
            width: 100,
            render: () => '합계',
          },
          {
            title: (
              <span style={{ lineHeight: 0.5 }}>
                Total
                <br />
                <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
                  (총매출+할인+환불)
                </span>
              </span>
            ),
            key: 'totalAmount',
            dataIndex: 'totalAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: (
              <span style={{ lineHeight: 0.5 }}>
                순매출
                <br />
                <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
                  (총매출-할인)
                </span>
              </span>
            ),
            key: 'totalNetAmount',
            dataIndex: 'totalNetAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '총 결제건수',
            key: 'totalCount',
            dataIndex: 'totalCount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '총 할인금액',
            key: 'totalDiscount',
            dataIndex: 'totalDiscount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '총 쿠폰적용 주문',
            key: 'totalCouponCount',
            dataIndex: 'totalCouponCount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '총 환불건수',
            key: 'totalRefundCount',
            dataIndex: 'totalRefundCount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '총 환불금액',
            key: 'totalRefundAmount',
            dataIndex: 'totalRefundAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '배송상품 결제 건수',
            key: 'totalDeliveryCount',
            dataIndex: 'totalDeliveryCount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '배송상품 결제 금액',
            key: 'totalDeliveryAmount',
            dataIndex: 'totalDeliveryAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '배송상품 순매출',
            key: 'totalDeliveryNetAmount',
            dataIndex: 'totalDeliveryNetAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '배송상품 할인',
            key: 'totalDeliveryDiscount',
            dataIndex: 'totalDeliveryDiscount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '배송상품 환불 건수',
            key: 'totalDeliveryRefundCount',
            dataIndex: 'totalDeliveryRefundCount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '배송상품 환불 금액',
            key: 'totalDeliveryRefundAmount',
            dataIndex: 'totalDeliveryRefundAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '스토어픽업 결제 건수',
            key: 'totalPickupCount',
            dataIndex: 'totalPickupCount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '스토어픽업 결제 금액',
            key: 'totalPickupAmount',
            dataIndex: 'totalPickupAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '스토어픽업 순매출',
            key: 'totalPickupNetAmount',
            dataIndex: 'totalPickupNetAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '스토어픽업 할인',
            key: 'totalPickupDiscount',
            dataIndex: 'totalPickupDiscount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '스토어픽업 환불 건수',
            key: 'totalPickupRefundCount',
            dataIndex: 'totalPickupRefundCount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '스토어픽업 환불 금액',
            key: 'totalPickupRefundAmount',
            dataIndex: 'totalPickupRefundAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '정기배송 결제 건수',
            key: 'totalSubscriptionCount',
            dataIndex: 'totalSubscriptionCount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '정기배송 결제 금액',
            key: 'totalSubscriptionAmount',
            dataIndex: 'totalSubscriptionAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '정기배송 순매출',
            key: 'totalSubscriptionNetAmount',
            dataIndex: 'totalSubscriptionNetAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '정기배송 할인',
            key: 'totalSubscriptionDiscount',
            dataIndex: 'totalSubscriptionDiscount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '정기배송 환불 건수',
            key: 'totalSubscriptionRefundCount',
            dataIndex: 'totalSubscriptionRefundCount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '정기배송 환불 금액',
            key: 'totalSubscriptionRefundAmount',
            dataIndex: 'totalSubscriptionRefundAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '렌탈 결제 건수',
            key: 'totalRentalCount',
            dataIndex: 'totalRentalCount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '렌탈 결제 금액',
            key: 'totalRentalAmount',
            dataIndex: 'totalRentalAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '렌탈 순매출',
            key: 'totalRentalNetAmount',
            dataIndex: 'totalRentalNetAmount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '렌탈 할인',
            key: 'totalRentalDiscount',
            dataIndex: 'totalRentalDiscount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '렌탈 환불 건수',
            key: 'totalRentalRefundCount',
            dataIndex: 'totalRentalRefundCount',
            render: (item) => stringToMoneyFormat(item),
          },
          {
            title: '렌탈 환불 금액',
            key: 'totalRentalRefundAmount',
            dataIndex: 'totalRentalRefundAmount',
            render: (item) => stringToMoneyFormat(item),
          },
        ];
      }
      default:
        return [];
    }
  }, [type]);

  // 데이터 정제
  const TableData = React.useMemo(() => {
    if (
      !orders.length &&
      !delivery.length &&
      !subscription.length &&
      !rental.length
    )
      return [];

    const t = {
      DELIVERY: 'Delivery',
      STORE_PICKUP: 'Pickup',
      SUBSCRIPTION: 'Subscription',
      RENTAL: 'Rental',
    };

    // 총 배송비, 사용 포인트
    const totalShopOrderAmount = orders.reduce(
      (acc, cur) => {
        const { type } = cur;

        acc.totalDeliveryAmount += cur.final_delivery_price;
        acc.totalPointAmount += Math.abs(cur.use_point);

        acc[`total${t[type]}DeliveryAmount`] += cur.final_delivery_price;
        acc[`total${t[type]}PointAmount`] += Math.abs(cur.use_point);

        return acc;
      },
      {
        totalDeliveryAmount: 0,
        totalPointAmount: 0,
        totalDeliveryDeliveryAmount: 0,
        totalDeliveryPointAmount: 0,
        totalPickupDeliveryAmount: 0,
        totalPickupPointAmount: 0,
        totalSubscriptionDeliveryAmount: 0,
        totalSubscriptionPointAmount: 0,
        totalRentalDeliveryAmount: 0,
        totalRentalPointAmount: 0,
      }
    );

    const newList = delivery.concat(subscription).concat(rental);

    // 공통
    const initial = {
      totalPaymentPrice: 0,
      totalCount: 0,
      totalDiscount: 0,
      totalCouponCount: 0,
      totalRefundCount: 0,
      totalRefundAmount: 0,
    };
    const typeInitial = Object.values(t).reduce((acc, cur) => {
      acc[`total${cur}PaymentPrice`] = 0;
      acc[`total${cur}Count`] = 0;
      acc[`total${cur}Discount`] = 0;
      acc[`total${cur}CouponCount`] = 0;
      acc[`total${cur}RefundCount`] = 0;
      acc[`total${cur}RefundAmount`] = 0;
      return acc;
    }, {});

    // Parcel, Rental별 결제금액, 할인금액, 환불금액 계산
    const summary = newList.reduce(
      (acc, cur) => {
        const { type, refund } = cur;

        if (refund) {
          acc.totalRefundCount += 1;
          acc.totalRefundAmount += refund.refund_amount;
          acc[`total${t[type]}RefundCount`] += 1;
          acc[`total${t[type]}RefundAmount`] += refund.refund_amount;
        }

        let paymentPrice = 0,
          discountPrice = 0;
        if (type === 'DELIVERY' || type === 'STORE_PICKUP') {
          paymentPrice = cur.payment_price;
          discountPrice = Math.abs(cur.discount_price);
        } else if (type === 'SUBSCRIPTION') {
          paymentPrice = cur.regular_payment_info.price;
          discountPrice =
            cur.regular_payment_info.regular_payment_id === 1
              ? Math.abs(cur.discount_price ?? 0)
              : Math.abs(cur.regular_payment_info.discount_price ?? 0);
        } else {
          paymentPrice = cur.rental_payment_info.price;
          discountPrice =
            cur.rental_payment_info.rental_payment_id === 1
              ? Math.abs(cur.discount_price ?? 0)
              : Math.abs(cur.rental_payment_info.discount_price ?? 0);
        }

        acc.totalPaymentPrice += paymentPrice;
        acc.totalCount += 1;
        acc.totalDiscount += discountPrice;
        acc.totalCouponCount += cur.coupon_info ? 1 : 0;

        acc[`total${t[type ?? 'RENTAL']}PaymentPrice`] += paymentPrice;
        acc[`total${t[type ?? 'RENTAL']}Count`] += 1;
        acc[`total${t[type ?? 'RENTAL']}Discount`] += discountPrice;
        acc[`total${t[type ?? 'RENTAL']}CouponCount`] += cur.coupon_info
          ? 1
          : 0;

        return acc;
      },
      {
        ...initial,
        ...typeInitial,
      }
    );

    // 총매출, 순매출 계산
    const totalInitial = ['totalAmount', 'totalNetAmount', 'totalDiscount'];
    const arrayKey = Object.values(t);
    const totalSummary = new Array(arrayKey.length + 1)
      .fill(null)
      .reduce((acc, _, idx) => {
        const k = arrayKey[idx] ?? '';

        totalInitial.forEach((item) => {
          const split = Object.values(item);

          const newKey = split.toSpliced(5, 0, k).join('');

          if (item === 'totalAmount') {
            acc[newKey] =
              summary[`total${k}PaymentPrice`] +
              summary[`total${k}Discount`] +
              totalShopOrderAmount[`total${k}PointAmount`] +
              totalShopOrderAmount[`total${k}DeliveryAmount`];
          } else if (item === 'totalNetAmount') {
            acc[newKey] =
              summary[`total${k}PaymentPrice`] -
              summary[`total${k}RefundAmount`] +
              totalShopOrderAmount[`total${k}DeliveryAmount`];
          } else {
            acc[newKey] =
              summary[`total${k}Discount`] +
              totalShopOrderAmount[`total${k}PointAmount`];
          }
        });

        return acc;
      }, {});

    return [
      {
        ...totalShopOrderAmount,
        ...summary,
        ...totalSummary,
      },
    ];
  }, [delivery, subscription, rental, orders]);

  // 숨김 컬럼에 따른 새로운 컬럼 정제
  const NewColumns = React.useMemo(() => {
    if (!disabled.length) return [];

    return Columns.filter((item) => {
      if (item.key === 'total') return true;
      else return disabled.includes(item.key);
    });
  }, [Columns, disabled]);

  React.useEffect(() => {
    const filter = Columns.filter((item) => item.key !== 'total');
    setData(filter);
  }, [Columns, setData]);
  /**!SECTION - Hooks */

  /**
   * SECTION - Render
   */
  return (
    <Content maxWidth={'100%'} padding={0}>
      <Table
        size="small"
        bordered
        columns={NewColumns}
        dataSource={TableData}
        locale={{
          emptyText: '검색된 판매 데이터가 없습니다',
        }}
        pagination={false}
        scroll={{ x: 200 * NewColumns.length }}
      />
    </Content>
  );
  /**!SECTION - Render */
};

export default ShopStatistics;
